module.exports = __webpack_public_path__ + "img/a7af288.jpg";